import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FaBookOpen, FaArrowRight } from 'react-icons/fa';
import ItemCard from './ItemCard';

const { Title, Paragraph } = Typography;

const ChallengesSection = ({ challengesData }) => (
  <Row gutter={16}>
    <Col span={24}>
      <section style={{ marginBottom: '40px' }}>
        <Title level={2} style={{ fontSize: '18px', display: 'flex', alignItems: 'center', color: '#1890ff' }}>
          <FaBookOpen style={{ marginRight: '8px' }} /> Challenges
        </Title>
        <Paragraph style={{ fontSize: '14px', color: '#666' }}>
          Participate in exciting challenges to test your skills.
        </Paragraph>
        <Row gutter={[16, 16]}>
          {(challengesData.Technology || []).slice(0, 4).map((challenge, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <ItemCard
                title={challenge.title}
                description={challenge.description}
                details={[["Days Left", challenge.daysLeft], ["Prize", challenge.price]]}
                type="challenges"
              />
            </Col>
          ))}
          {(!challengesData.Technology || challengesData.Technology.length === 0) && (
            <Col span={24}><Paragraph>No challenges available at the moment.</Paragraph></Col>
          )}
        </Row>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/challenges">
            <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }} aria-label="See all challenges">
              See All <FaArrowRight style={{ marginLeft: '8px' }} />
            </Button>
          </Link>
        </div>
      </section>
    </Col>
  </Row>
);

export default ChallengesSection;